import { IOperationEvent, OperationEvent } from '@augloop/tracelogger/dist/src/operation-event';
import { IClientMetadata } from '@augloop/schemas/dist/src/client/schemas';
import { IUserContext } from '@augloop/interfaces';
import { now } from './now';

export class Operation extends OperationEvent {
    public eventName: string = 'Operation';

    private startTime: number;

    public constructor(properties?: IOperationEvent, clientMetadata?: IClientMetadata, userContext?: IUserContext) {
        super(properties);

        if (!properties || properties.count == undefined) {
            this.count = 1;
        }

        if (clientMetadata) {
            this.setClientMetadata(clientMetadata);
        }

        if (userContext) {
            this.setUserContext(userContext);
        }
    }

    public setClientMetadata(clientMetadata: IClientMetadata): void {
        if (clientMetadata) {
            this.clientAppName = clientMetadata.appName;
            this.clientAppPlatform = clientMetadata.appPlatform;
            this.clientAppVersion = clientMetadata.appVersion;
            this.clientFlights = clientMetadata.flights;
            this.clientReleaseAudienceGroup = clientMetadata.releaseAudienceGroup;
            this.clientReleaseChannel = clientMetadata.releaseChannel;
            this.clientReleaseFork = clientMetadata.releaseFork;
            this.clientRuntimeVersion = clientMetadata.runtimeVersion;
            this.clientSessionId = clientMetadata.sessionId;
            this.clientDeviceId = clientMetadata.deviceId;
        }
    }

    public setUserContext(userContext: IUserContext): void {
        if (userContext) {
            // please ensure fields assigned here match those in userContextFieldNames in geneva-trace-logger.ts
            this.userId = userContext.puid || userContext.oid;
            this.userType = userContext.userType && userContext.userType.toString();
        }
    }

    public start(): Operation {
        this.startTime = now();
        return this;
    }

    public stop(): Operation {
        const stopTime = now();
        this.durationMs = Math.round(stopTime - this.startTime);
        return this;
    }
}
